define('home/templates/anonDownvoteCard',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"tooltip\">\n"
    + container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"You must sign in to down-vote this post.",{"name":"gettext","hash":{},"data":data}))
    + "\n</div>\n";
},"useData":true})

});
